module.exports = __webpack_public_path__ + "img/icon-listing-slim.3a3c6dbe.svg";